import {QRCode} from "react-qr-code";
import { useEffect, useState } from "react";
import { getCookie } from '../utils';

export default function UpiPayment({ studentId, batch, setEnrollments, setOpenUpiPayment }) {
  const [utr, setUtr] = useState("");
  const [status, setStatus] = useState("Pending");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const upiUrl =
    `upi://pay?pa=noorussabah8837@okaxis` +
    `&pn=MyStore` +
    `&am=${batch.fees}` +
    `&cu=INR` +
    `&tn=${studentId + '_' + batch.id}`;

    const submitPayment = async () => {
      setIsSubmitting(true);
      
  
      try {
        const token = getCookie('tsa_token');
        const apiHeaders = { 'Content-Type': 'application/json', 'x-auth-token': token || '' };
  
        // 1. PREPARE ENROLLMENT PAYLOAD
        const enrollmentPayload = {
          studentId: studentId,
          batchId: batch.id,
          EnrolledDate: new Date().toISOString(),
          ExpiryDate: new Date(Date.now() + (batch.validDays * 24 * 60 * 60 * 1000)).toISOString(),
          TotalHours: batch.hoursCount || 0,
          UsedHours: 0,
          TotalFees: batch.fees || 0,
          PaidFees: 0,
          active: false
        };
  
        // 2. POST TO ENROLMENTS API
        const enrollRes = await fetch('https://tsaapis.operate.live/api/enrolments', {
          method: 'POST',
          headers: apiHeaders,
          credentials: 'include',
          body: JSON.stringify(enrollmentPayload)
        });
  
        if (!enrollRes.ok) throw new Error("Failed to create enrollment record");
        const enrollData = await enrollRes.json();
        const newEnrollmentId = enrollData._id || enrollData.id;
  
        // 3. PREPARE PAYMENT PAYLOAD
        const paymentPayload = {
          EnrolmentId: newEnrollmentId,
          PaidAmount: batch.fees,
          PaidDT: new Date().toISOString(),
          Mode: 'UPI',
          TransactionRef: "UTR:" + utr || '',
          Status: 'Verification',
          Remarks: "Self Enrolled through UPI"
        };
  
        // 4. POST TO PAYMENTS API
        const payRes = await fetch('https://tsaapis.operate.live/api/payments', {
          method: 'POST',
          headers: apiHeaders,
          credentials: 'include',
          body: JSON.stringify(paymentPayload)
        });
  
        if (!payRes.ok) throw new Error("Failed to create payment record");
  
        // 5. UPDATE LOCAL STATE FOR INSTANT UI REFRESH
        const newLocalEnrollment = {
          id: newEnrollmentId,
          studentId: studentId,
          batchId: batch.id,
          startDay: new Date().toISOString(),
          endDay: new Date(Date.now() + (batch.validDays * 24 * 60 * 60 * 1000)).toISOString(),
          usedHours: 0, 
          balanceHours: batch.hoursCount || 0, 
          active: false
        };
        
        setEnrollments(prev => [...prev, newLocalEnrollment]);
        
        alert("Student Enrolled & Payment Verification Pending!");
        setOpenUpiPayment(false); 
  
      } catch (error) {
        console.error("API Error during enrollment:", error);
        alert("Error processing enrollment. Please check your connection and try again.");
      } finally {
        setIsSubmitting(false);
      }
    };
    

  return (
    <div>
      <h2>Pay ₹{batch.fees}</h2>

      <QRCode value={upiUrl} />

      {/* <p>Batch: {batch.title}</p> */}

      <input
        placeholder="Enter UTR"
        value={utr}
        onChange={(e) => setUtr(e.target.value)}
      />

      <button onClick={submitPayment} disabled={isSubmitting}>
        Submit UTR
      </button>

      <h3>Status: {status}</h3>
    </div>
  );
}